import React from 'react';
import img3 from "../../assets/images/career/everyone-cares-about-each-other.png";
import img4 from "../../assets/images/career/great-place-to-learn-and-grow.png";
import img5 from "../../assets/images/career/ready-for-innovation.png";
import img1 from "../../assets/images/career/fun-place-to-work.png";
import img6 from "../../assets/images/career/we-are-flexible-in-work-timings.png";
import img2 from "../../assets/images/career/we-are-results-oriented.png";
import Slider from "react-slick";
import { useState, useRef, useEffect } from 'react';
function WhyUs() {

  const slider = useRef(null);

  function scroll(e){
      e.preventDefault();
      if (slider === null)
          return 0;
  
      e.wheelDelta > 0 ? (
          slider.current.slickPrev()
      ) : (
          slider.current.slickNext()
      );
  
  };

  const settings = {
    infinite: true,
    speed: 1500,
    arrows: false,
    slidesToShow: 1,
    autoplay: false,
    dots: true,
    autoplaySpeed: 3000,
    slidesToScroll: 1,
    // swipeToSlide: true,
    vertical: true,
    verticalSwiping: true,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                vertical: false,
                verticalSwiping: false,
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                vertical: false,
                verticalSwiping: false,
            },
        },
    ],
};
  
  useEffect(() => {
      document.querySelector('.slider-sec2')?.addEventListener("wheel", scroll,true);
  
      return () => {
          document.querySelector('.slider-sec2')?.removeEventListener("wheel", scroll, true);
      };
  }, []);



  

  return (
    <>
        <section className='career-us'>
            <div className='container'>

            
                


                <div className='why-us-inner'>
                    <div className='top-head'>
                        <h2 className='ttl1'>Why Choose the Path of Collaboration <br/>with Us?</h2> 
                    </div>
                    <div className='slider-sec1'>
                    <Slider {...settings} ref={slider} className='slider-sec2'>
                      <div className='inr-cont-us'>
                          <div className='lft-inrr'>
                              <h3 className='ttl1'>Fun place to work</h3>
                              <p className='sm-para'>All work and no play makes us crabby and dull! Where there is laughter, joy, and fun, high-performance teams thrive.</p>
                          </div>
                          <div className='rght-inrr'>
                            <img src={img1} className="ban-img" alt='Fun place to work' width={427} height={345}/>
                          </div>
                      </div>
                      <div className='inr-cont-us'>
                          <div className='lft-inrr'>
                              <h3 className='ttl1'>We are results oriented</h3>
                              <p className='sm-para'>Results are important and we focus on resources to achieve them with positive actions combined with positive thinking.</p>
                          </div>
                          <div className='rght-inrr'>
                            <img src={img2} className="ban-img" alt='We are results oriented' width={427} height={345}/>
                          </div>
                      </div>
                      <div className='inr-cont-us'>
                          <div className='lft-inrr'>
                              <h3 className='ttl1'>Everyone cares about each other</h3>
                              <p className='sm-para'>A caring workplace and a supportive environment helps nurture positive relationships.</p>
                          </div>
                          <div className='rght-inrr'>
                            <img src={img3} className="ban-img" alt='Everyone cares about each other' width={427} height={345}/>
                          </div>
                      </div>
                      <div className='inr-cont-us'>
                          <div className='lft-inrr'>
                              <h3 className='ttl1'>Great place to learn and grow</h3>
                              <p className='sm-para'>A great place to learn and grow progressively that will fuel your career and give it a strong head start.</p>
                          </div>
                          <div className='rght-inrr'>
                            <img src={img4} className="ban-img" alt='Great place to learn and grow' width={427} height={345}/>
                          </div>
                      </div>
                      <div className='inr-cont-us'>
                          <div className='lft-inrr'>
                              <h3 className='ttl1'>Ready for Innovation</h3>
                              <p className='sm-para'>We encourage experimenting as without innovation there is no creativity or motivation for improvement.</p>
                          </div>
                          <div className='rght-inrr'>
                            <img src={img5} className="ban-img" alt='Ready for Innovation' width={427} height={345}/>
                          </div>
                      </div>
                      <div className='inr-cont-us'>
                          <div className='lft-inrr'>
                              <h3 className='ttl1'>We are flexible in work timings</h3>
                              <p className='sm-para'>We give flexibility in work timings to our team, which gives improved work-life balance, greater autonomy and improved morale.</p>
                          </div>
                          <div className='rght-inrr'>
                            <img src={img6} className="ban-img" alt='We are flexible in work timings' width={427} height={345}/>
                          </div>
                      </div>
                    </Slider>
                    </div>
                    

                </div>


            </div>            
        </section>
    </>

  )
}

export default WhyUs;
